export default __webpack_public_path__ + "static/media/misc-drawerB-1024w.58180c72.avif";